import utils from '@/utils'

export const useFunBookV2Store = defineStore('funbookV2', {
  state: () => ({
    branchId: null,
    domain: '',
    branchName: '',
    merchantName: '',
    logoImage: '',
    ogImage: '',
  }),
  actions: {
    async getFunBookV2LayoutData(axios, bid = '') {
      const url = `/pub/domain-setting?bid=${bid}`
      const res = await axios.$get(url)

      if (res.code !== 0) {
        throw new Error('getFunBookV2LayoutData response code is not 0')
      }
      this.branchId = res.data.branch_id
      this.domain = res.data.domain
      this.branchName = res.data.branch_name
      this.merchantName = res.data.merchant_name
      this.logoImage = res.data.branch_logo ? utils.getMediaCdnUrl(res.data.branch_logo) : ''
      this.ogImage = res.data.branch_cover_image ? utils.getMediaCdnUrl(res.data.branch_cover_image) : ''
    },
  },
})
